// import Viewer from 'viewerjs';
class imageViewer {
    init() {

    }

    initViewer() {
        lightbox.option({
            'resizeDuration': 200,
            'wrapAround': true 
          });
    }

}

window.app.add('images', new imageViewer());